/* eslint-disable import/first */
// Safari lacks the ReadableStream async iteration pdf.js relies on; install the polyfill before
// any PDF is loaded. TODO: remove once https://github.com/mozilla/pdf.js/issues/20973 ships.
import 'shared/domains/documents/utils/readableStreamAsyncIteratorPolyfill';
import { config } from '@fortawesome/fontawesome-svg-core';
// Disable auto CSS injection for CSP compliance.
// Run as soon as possible.
// @see https://docs.fontawesome.com/web/dig-deeper/security/
config.autoAddCss = false;
import { ApolloProvider } from '@apollo/client/react';
import { CSPProvider } from '@base-ui/react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { TetrisThemeProvider, StyleReset } from '@pocketlaw/tetris';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import client from 'external/domains/apollo';
import AuthProvider from 'external/domains/auth/passwordless/components/Provider';
import { GlobalCSS } from 'external/domains/common-ui';
import { AppVersionAlert } from 'shared/domains/common-ui';
import { ErrorBoundary } from 'shared/domains/errors';
import { FeatureFlagSettings } from 'shared/domains/featureFlag';
import { dangerouslySetCurrentLocale, defaultLocale } from 'shared/domains/languages/config';
import * as Sentry from 'shared/domains/sentry';
import { GtmProvider } from 'shared/domains/tracking';
import Routes from './routes';
Sentry.init({
    application: 'external',
});
function App() {
    // @ts-expect-error: __webpack_nonce__ is not defined on window
    // eslint-disable-next-line no-underscore-dangle
    const nonce = window.__webpack_nonce__ || '';
    return (<CSPProvider nonce={nonce} disableStyleElements>
      <TetrisThemeProvider>
        <StyleReset />
        <GlobalCSS />

        <I18nProvider i18n={i18n}>
          <ErrorBoundary>
            <GtmProvider>
              <AuthProvider>
                <ApolloProvider client={client}>
                  <BrowserRouter>
                    <Routes language={i18n.locale}/>
                    <AppVersionAlert />
                    <FeatureFlagSettings />
                  </BrowserRouter>
                </ApolloProvider>
              </AuthProvider>
            </GtmProvider>
          </ErrorBoundary>
        </I18nProvider>
      </TetrisThemeProvider>
    </CSPProvider>);
}
function render() {
    const container = document.getElementById('app-root');
    const root = createRoot(container);
    root.render(<App />);
}
dangerouslySetCurrentLocale(defaultLocale.code).then(render);
